module.exports = __webpack_public_path__ + "static/media/carousel-01.f9930fb7.jpg";